export default __webpack_public_path__ + "static/media/auroboros.e4297d03.svg";